export default "__VITE_ASSET__CYYPXDvP__"